import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Map } from 'immutable'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import _ from 'lodash'

import config from '../../../../../../config'

import { toggleBlock, loadBlockData, blockSaveCustomData } from './actions'

export default function (module) {
    function mapStateToProps(state, hocProps) {
        const id = hocProps.id
        const blockKey = hocProps.blockKey || ''
        const blockData = state.getIn(['ui', 'modules', module, 'workspace', id, 'blocks', blockKey], Map())
        const token = state.getIn(['ui', 'modules', module, 'workspace', id, 'token'], null)

        const blockAccessRightsPath = hocProps.blockAccessRightsPathFn(state, blockKey)
        const blockAccessRights = state.getIn(blockAccessRightsPath, Map())
        const defaultLevel = blockAccessRights.get('defaultLevel', '0') || '0'

        return {
            id,
            isActive: blockData.get('active', false),
            isLoaded: blockData.get('isLoaded', false),
            isLoading: blockData.get('isLoading', false),
            open: state.getIn(
                ['ui', 'workspace', module, id, 'blocks', blockKey, 'open'],
                config.components.block.open
            ),
            disable: state.getIn(['ui', 'workspace', module, id, 'blocks', blockKey, 'disable'], false),
            failed: state.getIn(['ui', 'workspace', module, id, 'blocks', blockKey, 'failed'], false),
            level: state.getIn(['ui', 'workspace', module, id, 'blocks', blockKey, 'level'], defaultLevel),
            customData: state.getIn(['ui', 'workspace', module, id, 'blocks', blockKey, 'customData'], {}),
            data: blockData.get('data', null),
            transformedData: blockData.get('transformedData', null),
            loadedLocale: blockData.get('loadedLocale', null),
            locale: state.getIn(['translate', 'locale']),
            token,
        }
    }

    function mapDispatchToProps(dispatch) {
        return bindActionCreators({ toggleBlock, loadBlockData, blockSaveCustomData }, dispatch)
    }

    return (InnerComponent) => {
        @connect(mapStateToProps, mapDispatchToProps, null, { areStatePropsEqual: _.isEqual })
        class HocConnect extends Component {
            static propTypes = {
                blockKey: PropTypes.string.isRequired,
                customData: PropTypes.object.isRequired,
                data: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
                disable: PropTypes.bool.isRequired,
                id: PropTypes.string.isRequired,
                isActive: PropTypes.bool.isRequired,
                isLoaded: PropTypes.bool.isRequired,
                isLoading: PropTypes.bool.isRequired,
                level: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
                loadedLocale: PropTypes.string,
                locale: PropTypes.string.isRequired,
                open: PropTypes.bool.isRequired,
                token: PropTypes.string,
                transformedData: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
            }

            render() {
                return <InnerComponent {...this.props} />
            }
        }

        return HocConnect
    }
}
